<ul class="latest-news">
  @for (item of items.value(); track item.id) {
    <li class="latest-news__item">
      <a [paiCmsLink]="item | apply: machMauLinkDrus" class="latest-news__link" paiRipple>
        <strong class="latest-news__item-title">{{ item.title }}</strong>
        <span class="latest-news__item-date">{{ item.date | date: 'longDate' }}</span>
        <p class="latest-news__item-excerpt">{{ item.excerpt }}</p>
        <pai-icon class="latest-news__item-icon" icon="chevron_right" />
      </a>
    </li>
  }
</ul>
